import {
  IGlobalPaidOrganicData,
  IGlobalTrafficData,
  IPopularData,
  ISearchInterestData,
  ISocialNetworks,
} from "../../constants/interface/ariya";
import { fetchDataV2, postDataV2 } from "../utils";
import { apiPrefix } from "./constants";

export const fetchSearchValuesData = (): Promise<ISearchInterestData> => postDataV2(`${apiPrefix}/searchValues`, {});
export const fetchSearchVolumesData = (): Promise<Array<{ country: string; date: string; search_term: string; search_volume: number }>> =>
  fetchDataV2(`${apiPrefix}/search_volume`);
export const fetchVLPData = (): Promise<IGlobalTrafficData> => postDataV2(`${apiPrefix}/globalTrafficVLP_Visits_for_testing`, {});
export const fetchVLP_PreviousData = (): Promise<IGlobalTrafficData> => postDataV2(`${apiPrefix}/globalTrafficVLP_VisitsPrevious`, {});
export const fetchVCData = (): Promise<IGlobalTrafficData> => postDataV2(`${apiPrefix}/globalTrafficVCVisits_for_testing`, {});
export const fetchVC_PreviousData = (): Promise<IGlobalTrafficData> =>
  postDataV2(`${apiPrefix}/globalTrafficVCVisitsPrevious_for_testing`, {});
export const fetchWPData = (): Promise<IGlobalTrafficData> => postDataV2(`${apiPrefix}/globalTrafficWPVisits_for_testing`, {});
export const fetchWP_PreviousData = (): Promise<IGlobalTrafficData> =>
  postDataV2(`${apiPrefix}/globalTrafficWPVisitsPrevious_for_testing`, {});
export const fetchPaidOrganicData = (): Promise<IGlobalPaidOrganicData> =>
  postDataV2(`${apiPrefix}/globalTrafficPaidOrganicVisits_for_testing`, {});

export const fetchPopularContent = (): Promise<IPopularData> => postDataV2(`${apiPrefix}/mostPopularFramesVlp_for_testing`, {});
export const fetchPopularMoments = (): Promise<IPopularData> => postDataV2(`${apiPrefix}/mostPopularMomentsVc_for_testing`, {});
export const fetchSocialNetworks = (): Promise<ISocialNetworks> => postDataV2(`${apiPrefix}/socialNetworksDrillDown_for_testing`, {});
